module.exports = __webpack_public_path__ + "8820d0946b37e45cc55e0e46bbcb257a.fbx";